export enum MuiButtonVariant {
  contained = 'contained',
  outlined = 'outlined',
  textq = 'text',
}
